export default "__VITE_ASSET__cVeNN2kj__"